
jQuery(function () {
    var containers = document.querySelectorAll('[data-container=svgLinks]');

    if (containers.length) {
        [].forEach.call(containers, function(container) {
            JSON.parse(container.dataset.links).forEach(function (link) {
                var el = container.querySelector('#' + link.id);

                if (el) {
                    el.classList.add('clickable');
                    el.addEventListener('click', function () {
                        if (link.target && link.target !== '_top' && link.target !== '_self') {
                            window.open(link.uri, link.target);
                        } else {
                            top.location.href = link.uri;
                        }
                    });
                }
            });
        });
    }
});
